import { ParsedUrlQuery } from "querystring"
import { useState, useEffect } from "react"
import { UrlObject } from "url"

// staticファイルのパスを生成
export const staticPath = (path: string): string => {
  return `/next${path}`
}

// hrefリンクパスを生成
export function internalLink(path: string): string
export function internalLink(path: string, linkObject: Omit<UrlObject, "pathname">): UrlObject
export function internalLink(path: string, linkObject?: Omit<UrlObject, "pathname">): string | UrlObject {
  const pathname = path === "/" ? "/next" : `/next${path}`
  if (!linkObject) {
    return pathname
  }
  return { ...linkObject, pathname }
}

/** @deprecated TODO: useMobileMedia を使用する */
export const checkMobile = () => {
  if (typeof window === "undefined") {
    return [false] as const
  }

  const [isMobile, setIsMobile] = useState<boolean>(false)

  useEffect(() => {
    setIsMobile(window.matchMedia("screen and (max-width: 767px)").matches)
  }, [])

  return [isMobile] as const
}

export const canonicalUrl = (path: string, parsedQuery?: ParsedUrlQuery): string => {
  let query = ""
  // NOTE: 2ページ目以降を指定するパラメーターのみ canonical の URL に含める
  if (parsedQuery && Number(parsedQuery.page) > 1) {
    const page = { page: String(parsedQuery.page) }
    query = "?" + new URLSearchParams(page).toString()
  }

  return process.env.APP_HOST + path + query
}
